import React, { useEffect, useState } from "react"
import { getAppointmentById, getManageStaffDetailsById, getPatientDetail, getSmartSummaryData } from "../../core/services/api"
import { getPatientHistory } from "../../core/services/api/patientDiagnosisService"
import { IPatient } from "../../core/services/models/Patient"
import Tests from "./components/tests/Tests"
import ChemoOrder from "./components/chemoOrder/ChemoOrder"
import DischargeSummary from "./components/dischargeSummary/DischargeSummary"
import Forms from "./components/forms/Forms"
import DocumentCard from "./components/DocumentCard"
import DocumentsRMO from "./components/documents/DocumentRMO"
import NursingNotes from "./components/nursingNotes/NursingNotes"
import PatientHistoryCard from "./components/PatientHistoryCard"
import "./PatientDiagnosisDrawer.scss"
import { useLocation } from "react-router"
import { useTheme } from "@emotion/react"
import { styles } from "../../resources/styles/Styles"
import { HistoryViewStyles } from "../../resources/styles/pages/HistoryViewStyles"
import { useSelector } from "react-redux"
import { MocUserRole } from "../../core/services/models/Enums"
import MandatoryConsentForm from "components/MandatoryConsentForm/MandatoryConsentForm"
import { AppointmentStatus } from "core/services/models/AppointmentDetail"
import Alert from 'react-bootstrap/esm/Alert'

export default function PatientDiagnosisDrawer({ patientId, isReadOnly }: any) {
  const theme = useTheme()
  const globalStyles = styles(theme)
  const classes = HistoryViewStyles(theme)
  //Relevant Documents right side Drawer
  const [test, setTest] = useState(false)
  const [chemo, setChemo] = useState(false)
  const [dischargeSummary, setdischargeSummary] = useState(false)
  const [docsRMO, setdocsRMO] = useState(false)
  const [nurseNotes, setnurseNotes] = useState(false)
  const [forms, setForms] = useState(false)
  const [show, setShow] = useState<any>(false)
  const [patientCurrentData, setPatientCurrentData] = useState<any>()
  const [patientHistoryData, setPatientHistoryData] = useState([{}])
  const [patientDetail, updatePatientDetail] = React.useState<IPatient>()
  const [appointmentDetails, setAppointmentDetails] = useState<any>({})
  const [staffDetails, setStaffDetails] = useState<any>({})
  const [smartSummaryDetails, setSmartSummaryDetails] = useState<any>({})
  const location = useLocation()
  const appointmentId = new URLSearchParams(location.search).get(
    "appointmentId"
  )
  const userRole = useSelector((state: any) => state?.user?.role)

  useEffect(() => {
    if (patientId) {
      getPatientHistory(patientId)
        .then((res: any) => {
          const past = res.data.filter((a: any) => a?.id !== appointmentId)
          setPatientHistoryData(past)
        })
        .catch((err: any) => console.log("err in get patient history", err))

      getPatientDetail(patientId)
        .then((res: any) => {
          updatePatientDetail(res)
        })
        .catch((err: any) => {
          console.log("err", err)
        })

      getSmartSummaryData(patientId)
        .then((res: any) => {
          setSmartSummaryDetails(res?.data)
        })
    }
  }, [patientId, appointmentId])

  useEffect(() => {
    if (appointmentId) {
      getAppointmentById(appointmentId)
        .then((res: any) => {
          setAppointmentDetails(res)
          setPatientCurrentData(res)
        })
        .catch((err: any) => {
          console.log(err?.message)
        })
    }
  }, [appointmentId])

  useEffect(() => {
    if (appointmentDetails && patientDetail) {
      if (appointmentDetails?.consultantId) {
        getStaffType(appointmentDetails?.consultantId)
      } else if (patientDetail?.primaryConsultantId) {
        getStaffType(patientDetail?.primaryConsultantId)
      }
    }
  }, [appointmentDetails, patientDetail])

  const relevantDocumentList = [
    { text: "Tests", img: "../../assets/images/test-icon.svg" },
    { text: "All Documents", img: "../../assets/images/document-icon.svg" },
    { text: "Chemo Order", img: "../../assets/images/chemo-icon.svg" },
    {
      text: "Discharge Summary",
      img: "../../assets/images/discharge-icon.svg",
    },
    { text: "Nursing Notes", img: "../../assets/images/nursing-icon.svg" },
    { text: "Forms", img: "../../assets/images/forms.svg" },
  ]

  const getStaffType = (id: any) => {
    if (id) {
      getManageStaffDetailsById(id)
        .then((res: any) => {
          setStaffDetails(res)
        })
        .catch((err: any) => console.log(err?.message))
    }
  }

  function renderAccordionContentRow(component: any, data: any) {
    return (
      <div className="col-md-12 col-lg-12 m-0 p-0 row">
        <div className={`${globalStyles.relative}`}>
          <div className={classes.dividerLine} />
        </div>

        <div className={`${classes.accordionEachRow} col-md-12 col-lg-12 m-0 p-0 row`}>
          <div
            className={`${globalStyles.pl0} ${globalStyles.pr0} text-center ${classes.dividerSection}`}
          >
            {
              data?.id === appointmentId ? (
                <img
                  alt="green circle"
                  src={"../../../assets/images/switchGreenCircle.svg"}
                />
              ) : (
                <img
                  alt="red circle"
                  src={"../../../assets/images/switchRedCircle.svg"}
                />
              )
            }
          </div>
          {/* <div className="col-md-1"></div> */}
          <div className={`col-md-10 col-lg-10 p-0 ${classes.btmBorder}`}>
            {component}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="patient-diagnosis-drawer">
      {appointmentDetails?.status === AppointmentStatus.CANCELLED ||
        appointmentDetails?.status === AppointmentStatus.NO_SHOW ?
        <div className="heading">
          <Alert variant="danger">
            Appointment is cancelled
          </Alert>
        </div>
        : (
          <>
            <div className="heading">Relevant Documents</div>
            <div className="document-wrapper">
              <DocumentCard
                img={"../../assets/images/test-icon.svg"}
                text="Tests"
                onClick={() => {
                  setTest(true)
                }}
              />
              <div style={{ display: "none" }}>
                {test === true && (
                  // <TestsRMO
                  //   closePrintModal={setTest}
                  //   patientIdRMO={patientId}
                  //   patientMOC={patientDetail}
                  //   readOnly={isReadOnly}
                  // />
                  <Tests
                    closePrintModal={setTest}
                    patientIdRMO={patientId}
                    patientMOC={patientDetail}
                    readOnly={isReadOnly}
                    appointmentDetails={appointmentDetails}
                    smartSummaryData={smartSummaryDetails}
                  />
                )}
              </div>
              <DocumentCard
                img={"../../assets/images/document-icon.svg"}
                text="All Documents"
                onClick={() => {
                  setdocsRMO(true)
                }}
              />
              <div style={{ display: "none" }}>
                {docsRMO === true && (
                  <DocumentsRMO
                    patientMOC={patientDetail}
                    closePrintModal={setdocsRMO}
                  />
                )}
              </div>
            </div>
            <div className="document-wrapper">
              <DocumentCard
                img={"../../assets/images/chemo-icon.svg"}
                text="Chemo Order"
                onClick={() => {
                  setChemo(true)
                }}
              />
              {chemo === true && (
                <MandatoryConsentForm
                  appointmentDetails={appointmentDetails}
                  appointmentId={appointmentId}
                  staffDetails={staffDetails}
                  patientDetail={patientDetail}
                  smartSummaryData={smartSummaryDetails}
                  closeModal={() => { setChemo(false) }}
                  showWarningOnly={false}
                  readOnly={isReadOnly}
                >
                  <ChemoOrder
                    closePrintModal={setChemo}
                    patientMOC={patientDetail}
                    smartSummaryDetails={smartSummaryDetails}
                    readOnly={isReadOnly}
                    appointmentDetails={appointmentDetails}
                  />
                </MandatoryConsentForm>
              )}
              <DocumentCard
                img={"../../assets/images/discharge-icon.svg"}
                text="Discharge Summary"
                onClick={() => {
                  setdischargeSummary(true)
                }}
              />
              {dischargeSummary === true && (
                <MandatoryConsentForm
                  appointmentDetails={appointmentDetails}
                  appointmentId={appointmentId}
                  staffDetails={staffDetails}
                  patientDetail={patientDetail}
                  smartSummaryData={smartSummaryDetails}
                  closeModal={() => { setdischargeSummary(false) }}
                  showWarningOnly={false}
                  readOnly={isReadOnly}
                >
                  <DischargeSummary
                    closePrintModal={setdischargeSummary}
                    patientMOC={patientDetail}
                    appointmentId={appointmentId}
                    appointmentDetails={appointmentDetails}
                    smartSummaryDetails={smartSummaryDetails}
                    readOnly={isReadOnly}
                  />
                </MandatoryConsentForm>
              )}
            </div>
            <div className="document-wrapper">
              <DocumentCard
                img={"../../assets/images/nursing-icon.svg"}
                text="Nursing Notes"
                onClick={() => {
                  setnurseNotes(true)
                }}
              />
              {nurseNotes === true && (
                <MandatoryConsentForm
                  appointmentDetails={appointmentDetails}
                  appointmentId={appointmentId}
                  staffDetails={staffDetails}
                  patientDetail={patientDetail}
                  smartSummaryData={smartSummaryDetails}
                  closeModal={() => { setnurseNotes(false) }}
                  showWarningOnly={false}
                  readOnly={isReadOnly}
                >
                  <NursingNotes
                    closePrintModal={setnurseNotes}
                    patientMOC={patientDetail}
                    appointmentId={appointmentId}
                    smartSummaryDetails={smartSummaryDetails}
                    readOnly={userRole !== MocUserRole.NURSE}
                  />
                </MandatoryConsentForm>
              )}
              <DocumentCard
                img={"../../assets/images/forms.svg"}
                text="Forms"
                onClick={() => {
                  setShow(true)
                }}
              />
              <div style={{ display: "none" }}>
                {show && (
                  <Forms
                    closePrintModal={setForms}
                    show={show}
                    setShow={setShow}
                    patientInfo={patientDetail}
                    appointmentId={appointmentId}
                    appointment={appointmentDetails}
                    staffInfo={staffDetails}
                  />
                )}
              </div>
            </div>
            {
              patientCurrentData?.id && (
                <div>
                  <div className="heading pt-1">Current</div>
                  <div className="patient-history-card">
                    {
                      renderAccordionContentRow(
                        <PatientHistoryCard
                          data={patientCurrentData}
                          enableExpandedView={false}
                          isCurrrentView={true}
                        />,
                        patientCurrentData
                      )
                    }
                  </div>
                </div>
              )
            }
            <div className="heading pt-1">Patient History</div>
            <div className="patient-history-card-hist">
              {patientHistoryData?.map((pastAppointmentData: any) => (
                renderAccordionContentRow(
                  <PatientHistoryCard
                    data={pastAppointmentData}
                    enableExpandedView={true}
                  />,
                  pastAppointmentData
                )
              ))}
            </div>
          </>
        )}
    </div>
  )
}
